import { render } from "./DetalleCarteras.vue?vue&type=template&id=6e00cb82&scoped=true"
import script from "./DetalleCarteras.vue?vue&type=script&lang=js"
export * from "./DetalleCarteras.vue?vue&type=script&lang=js"

import "./DetalleCarteras.vue?vue&type=style&index=0&id=6e00cb82&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e00cb82"]])

export default __exports__